module.exports = __webpack_public_path__ + "img/2.d18a3d3.jpg";